import React from 'react';
import { Button, Checkbox, Space, Tag, Typography } from 'antd';
import { CheckCircleOutlined, AppstoreOutlined } from '@ant-design/icons';
import './styles.scss';

const { Paragraph, Text, Title } = Typography;

const AccessSelectionPanel = ({
	description,
	helpText,
	summaryLabel,
	summaryValue,
	pinnedLabel,
	pinnedCopy,
	selectAllLabel,
	clearAllLabel,
	onSelectAll,
	onClearAll,
	allSelected,
	enabledLabel,
	disabledLabel,
	options,
	selectedValues,
	onToggle,
	getOptionDescription,
}) => {
	return (
		<div className="access-selection-panel">
			<div className="access-selection-panel__hero">
				<div className="access-selection-panel__copy">
					<Paragraph className="access-selection-panel__description">{description}</Paragraph>
					<Text type="secondary" className="access-selection-panel__help">
						{helpText}
					</Text>
				</div>
				<div className="access-selection-panel__summary">
					<Text type="secondary">{summaryLabel}</Text>
					<Title level={4}>{summaryValue}</Title>
				</div>
			</div>

			<div className="access-selection-panel__toolbar">
				{pinnedLabel && (
					<div className="access-selection-panel__pinned">
						<Tag color="blue" icon={<AppstoreOutlined />}>
							{pinnedLabel}
						</Tag>
						<Text>{pinnedCopy}</Text>
					</div>
				)}
				<Space wrap>
					<Button type="link" onClick={onSelectAll}>
						{selectAllLabel}
					</Button>
					<Button type="link" onClick={onClearAll} disabled={!selectedValues.length}>
						{clearAllLabel}
					</Button>
					{allSelected ? (
						<Tag color="green" icon={<CheckCircleOutlined />}>
							{enabledLabel}
						</Tag>
					) : null}
				</Space>
			</div>

			<div className="access-selection-panel__grid">
				{options.map((option) => {
					const checked = selectedValues.includes(option.value);

					return (
						<button
							type="button"
							key={option.value}
							className={`access-selection-panel__card ${checked ? 'is-selected' : ''}`}
							onClick={() => onToggle(option.value)}
						>
							<div className="access-selection-panel__card-header">
								<div
									className="access-selection-panel__checkbox-wrap"
									onClick={(event) => event.stopPropagation()}
								>
									<Checkbox checked={checked} onChange={() => onToggle(option.value)}>
										{option.label}
									</Checkbox>
								</div>
								<Tag color={checked ? 'green' : 'default'}>{checked ? enabledLabel : disabledLabel}</Tag>
							</div>
							<Text type="secondary" className="access-selection-panel__card-copy">
								{getOptionDescription(option)}
							</Text>
						</button>
					);
				})}
			</div>
		</div>
	);
};

export default AccessSelectionPanel;